<template>
    <el-dialog
        title="释放费用"
        width="600px"
        :visible="true"
        :append-to-body="true"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :before-close="beforeClose"
        :custom-class="'releaseFeeDialog'"
        >
        <el-form ref="formRef" :model="formData" :rules="rules" label-width="120px">
            <el-form-item label="供应商：" prop="supplier">
                <el-select style="width: 380px" :disabled="true" v-model="formData.supplier" @change="getSelectValue" placeholder="请选择供应商">
                    <el-option
                        v-for="item in supplierOptionList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="可释放发车单：">{{ formData.departureOrderNum }} 单</el-form-item>
            <el-form-item label="可释放金额：">{{ formData.amount }} 元</el-form-item>
        </el-form>
        <div class="release-fee-dialog-tips">注：同个供应商下，发车单分账状态为已分账且支付状态为已支付、司机收款确认状态为已确认收到的费用，可以解冻释放。释放后，解冻释放状态变更为“已释放”的费用，可以在美的付发起提现</div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="beforeClose">取 消</el-button>
            <el-button :disabled="!formData.amount" type="primary" :loading="btnLoading" @click="handleSubmit">确认释放</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { queryThawing, thawing } from '@/modules/transport/otp/api/driverExpenseUnfreezeAndBalance.js';
export default {
    name: 'releaseFeeDialog',
    props: {
        supplier: {
            type: Object,
            default: () => {}
        }
    },
    data () {
        return {
            btnLoading: false,
            formData: {
                supplier: '',
                departureOrderNum: 0,
                amount: 0
            },
            rules: {
                supplier: [
                    {
                        required: true,
                        message: '请选择供应商',
                        trigger: ['blur', 'change']
                    }
                ]
            }
        };
    },
    computed: {
        supplierOptionList() {
            return [
                {
                    label: this.supplier.supplierNameCn,
                    value: this.supplier.supplierCode
                }
            ]
        }
    },
    async mounted () {
        this.formData.supplier = this.supplier.supplierCode
        this.getSupplierAmount()
    },
    methods: {
        // 获取供应商可释放金额、供应商可释放发车单
        getSupplierAmount() {
            queryThawing({
                carrierCode: this.supplier.supplierCode
            }).then(res => {
                this.formData.departureOrderNum = res.data.dispatchNoCount
                this.formData.amount = res.data.totalThawingAmount
            })
        },
        /**
         * @description: 高级下拉选中的回调
         * @param {*} data 选中的数据
         * @return {*}
         */
        getSelectValue (data) {
            Object.keys(data).forEach(key => {
                this.formData[key] = data[key];
            });
        },
        /**
         * @description 关闭
         */
        beforeClose () {
            this.$emit('update:releaseFeeDialogShow', false);
        },
        /**
         * @description 提交
         */
        handleSubmit () {
            this.$refs.formRef.validate(valid => {
                if (valid) {
                    this.btnLoading = true;
                    thawing({
                        carrierCode: this.supplier.supplierCode
                    }).then(res => {
                        if (res && +res.code === 0) {
                            this.$message.success(res.data);
                            this.$emit('refresh')
                        } else {
                            this.$message.error('释放接口调用失败');
                        }
                    }).catch(() => {
                    }).finally(() => {
                        this.btnLoading = false
                        this.beforeClose()
                    })
                };
            });
        }
    }
};
</script>

<style lang="less">
.releaseFeeDialog{
    .el-dialog__body {
        padding: 16px 36px 16px 16px;
    }
    .release-fee-dialog-tips {
        color: #D9001B;
    }
}
</style>
